import { connect } from 'react-redux';
import { State } from '~/Store';

import HelpPage from './HelpPage';

const mapStateToProps = ({ accessToken }: State) => ({
	user: accessToken.accessToken?.user,
});

export default connect(mapStateToProps)(HelpPage);
